module.exports = {"511826100":"芦阳镇","511826101":"飞仙关镇","511826102":"双石镇","511826103":"太平镇","511826104":"大川镇","511826200":"思延乡","511826201":"清仁乡","511826202":"龙门乡","511826203":"宝盛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511826.json
// module id = 2201
// module chunks = 0